import React from "react";
import { IoHomeSharp } from "react-icons/io5";
import {
  MdLocalPostOffice,
  MdOutlineMiscellaneousServices as MdServices,
} from "react-icons/md";
import { RiProjectorFill } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

const menuItems = [
  { path: "/", icon: IoHomeSharp, label: "Home" },
  { path: "/projects", icon: RiProjectorFill, label: "Projects" },
  { path: "/services", icon: MdServices, label: "Services" },
  { path: "/aboutme", icon: FaUser, label: "About" },
  { path: "/contact", icon: MdLocalPostOffice, label: "Contact" },
  // { path: "/blog", icon: FaMicroblog, label: "Blog" },
];

const NavbarShort = () => {
  const { pathname } = useLocation();
  const isCurrentPath = (path) => {
    if (path === "/projects" && pathname.startsWith("/projects")) {
      return true;
    }
    return pathname === path;
  };
  return (
    <nav className="navbar text-accent bg-error w-full show-navbarShort absolute bottom-0 [z-index:999]">
      <div className="w-full">
        <ul className="flex items-center w-full justify-evenly">
          {menuItems.map((item, index) => (
            <li
              key={index}
              className={`transition-all ${
                isCurrentPath(item.path) ? "mb-4" : "text-slate-200 opacity-20"
              }`}
            >
              <Link to={item.path} className="flex flex-col items-center">
                <item.icon />
                <small>{item.label}</small>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default NavbarShort;
